(function() {

  em.postArchive = {};
  
  em.postArchive.init = function() {

      var archives = document.querySelectorAll('.js-post-archive');

      for( var i = 0; i < archives.length; i++ ) {
          em.postArchive.setup( archives[i] );
      }

  };

  /**
   * SETUP A SINGLE INSTANCE
   */
  em.postArchive.setup = function( el ) {

      // get post archive settings
      var pageSize = el.getAttribute('data-page-size');
      var postType = el.getAttribute('data-post-type');
      var postIds = el.getAttribute('data-posts');
      var bigItems = el.getAttribute('data-add-big-items');

      // get element initial state
      em.postArchive.getCategories( el );
      el.postType = postType ? postType : 'post';
      el.pageSize = pageSize;
      el.postIds = postIds;
      el.page = 1;
      el.bigItems = bigItems;

      // category menu link functionality
      em.postArchive.setupCategoryMenu( el );

      // load more functionality
      em.postArchive.setupLoadMore( el );

      // load the initial content
      em.postArchive.load( el );

  };

  /**
   * Read selected categories
   */
  em.postArchive.getCategories = function( el ) {
      var categories = [];

      var filters = el.querySelectorAll('.js-post-archive-categories a');
      if ( ! filters || ! filters.length ) {
          return categories;
      }

      for ( var i = 0; i < filters.length; i++ ) {
          if ( filters[i].classList.contains('is-selected') ) {
              var matches = /category=(\d+)/.exec( filters[i].href ); // extract category ID from the link href
              if ( matches && matches[1] && matches[1] != '0' ) {
                  categories.push( matches[1] );
              }
          }
      }

      el.categories = categories; // store right into the dom node

      return categories;
  };

  /**
   * Setup Category Menu
   */
  em.postArchive.setupCategoryMenu = function( el ) {

      var filters = el.querySelectorAll('.js-post-archive-categories a');

      for ( var i = 0; i < filters.length; i++ ) {
          filters[i].context = el; // save a reference to the post archive instance
          filters[i].addEventListener('click', em.postArchive.categoryMenuClick );
      }

  };

  /**
   * Category menu filter click handler
   */
  em.postArchive.categoryMenuClick = function( event ) {

      var el = this.context;

      // unselect all filters
      var filters = el.querySelectorAll('.js-post-archive-categories a');
      for ( var i = 0; i < filters.length; i++ ) {
          filters[i].classList.remove('is-selected');
      }

      // mark this filter selected
      this.classList.add('is-selected');

      // update the stored categories state
      em.postArchive.getCategories( el );

      // reset current page
      el.page = 1;

      var loadMore = el.querySelector('.js-load-more');

      if (loadMore && loadMore.classList) {
          // undisable load more
          el.querySelector('.js-load-more').classList.remove('is-disabled');
      }

      // update the posts list
      em.postArchive.load( el );

      em.postArchive.filter( el );

  };

  em.postArchive.filter = function( el ) {
      var cat = el.categories && el.categories[0];
      if (cat) {
          var filters = el.querySelectorAll('div[data-category-id]');
          for ( var i = 0; i < filters.length; i++ ) {
              if (filters[i].dataset.categoryId == cat) {
                  filters[i].classList.remove('is-disabled');
              } else {
                  filters[i].classList.add('is-disabled');
              }
          }
      } else {
          var filters = el.querySelectorAll('div[data-category-id]');
          for ( var i = 0; i < filters.length; i++ ) {
              filters[i].classList.remove('is-disabled');
          }
      }
  }

  /**
   * Setup Load More button
   */
  em.postArchive.setupLoadMore = function( el ) {

      var loadMore = el.querySelector('.js-load-more');
      if ( loadMore == null ) {
          return false;
      }

      loadMore.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          if ( this.classList.contains('is-disabled') ) {
              return false;
          }

          el.page += 1;

          em.postArchive.load( el, true );
      });

  };

  /**
   * LOAD POSTS
   */
  em.postArchive.load = function( el, append ) {

      var params = {
          'action'         : 'ict_post_archive',
          'categories'     : el.categories,
          'page'           : el.page,
          'posts_per_page' : el.pageSize,
          'post_type'      : el.postType,
          'post_ids'       : el.postIds,
          'big_items'      : append ? 0 : el.bigItems
      };

      var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
      xhr.open('GET', myquery_wp.ajax_url + '?' + em.postArchive.serialize(params));
      xhr.onreadystatechange = function() {
          if ( xhr.readyState > 3 && xhr.status == 200 ) {

              // handle response
              if ( ! xhr.responseText ) {
                  // empty response
                  el.querySelector('.js-load-more').classList.add('is-disabled');
              } else {
                  var target = el.querySelector('.js-post-archive-items');
                  if ( append ) {
                      target.innerHTML += xhr.responseText;
                  } else {
                      target.innerHTML = xhr.responseText;
                  }
                  em_modal.init();
              }


          }
      };
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send();

  };

  /**
   * Helper function to serialize a JS object into query parameter string
   */
  em.postArchive.serialize = function(obj, prefix) {
      var str = [], p;
      for (p in obj) {
          if (obj.hasOwnProperty(p)) {
              var k = p, v = obj[p];
              str.push((v !== null && typeof v === "object") ?
                  encodeURIComponent(k) + "=" + encodeURIComponent(v.join(',')) :
                  encodeURIComponent(k) + "=" + encodeURIComponent(v)
              );
          }
      }
      return str.join("&");
  };

})();
